module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibolditalic.c7e698a4.ttf";